
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 4.10.0
 * Query Engine version: ca7fcef713137fa11029d519a9780db130cca91d
 */
Prisma.prismaVersion = {
  client: "4.10.0",
  engine: "ca7fcef713137fa11029d519a9780db130cca91d"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val


/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */
// Based on
// https://github.com/microsoft/TypeScript/issues/3192#issuecomment-261720275
function makeEnum(x) { return x; }

exports.Prisma.AccountScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  type: 'type'
});

exports.Prisma.AnalyticsEventScalarFieldEnum = makeEnum({
  id: 'id',
  stamp: 'stamp',
  sessionId: 'sessionId',
  userId: 'userId',
  eventName: 'eventName',
  data: 'data'
});

exports.Prisma.AssetScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  symbol: 'symbol',
  decimals: 'decimals',
  assetType: 'assetType'
});

exports.Prisma.BetConfigurationHistoryScalarFieldEnum = makeEnum({
  configId: 'configId',
  stamp: 'stamp',
  pair: 'pair',
  priceSource: 'priceSource',
  settlementAssetId: 'settlementAssetId',
  betDurationSec: 'betDurationSec',
  version: 'version',
  isActive: 'isActive',
  betMin: 'betMin',
  betMax: 'betMax',
  leverageUp: 'leverageUp',
  leverageDown: 'leverageDown'
});

exports.Prisma.BetConfigurationScalarFieldEnum = makeEnum({
  id: 'id',
  pair: 'pair',
  priceSource: 'priceSource',
  settlementAssetId: 'settlementAssetId',
  betDurationSec: 'betDurationSec',
  isActive: 'isActive',
  betMin: 'betMin',
  betMax: 'betMax',
  leverageUp: 'leverageUp',
  leverageDown: 'leverageDown',
  dailySpendingLimit: 'dailySpendingLimit'
});

exports.Prisma.BetScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  configId: 'configId',
  configVersion: 'configVersion',
  deadline: 'deadline',
  isUp: 'isUp',
  strikePrice: 'strikePrice',
  settlementAssetId: 'settlementAssetId',
  amount: 'amount',
  makerId: 'makerId',
  takerId: 'takerId'
});

exports.Prisma.DataMigrationScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  stamp: 'stamp'
});

exports.Prisma.ETHAddressScalarFieldEnum = makeEnum({
  address: 'address',
  networkId: 'networkId'
});

exports.Prisma.ETHBlockScalarFieldEnum = makeEnum({
  hash: 'hash',
  networkId: 'networkId',
  height: 'height',
  timestamp: 'timestamp',
  prevHash: 'prevHash'
});

exports.Prisma.ETHDepositEventScalarFieldEnum = makeEnum({
  eTHEventId: 'eTHEventId',
  userAddress: 'userAddress',
  amount: 'amount'
});

exports.Prisma.ETHEventScalarFieldEnum = makeEnum({
  eTHEventId: 'eTHEventId',
  blockHash: 'blockHash',
  logIndex: 'logIndex',
  transactionHash: 'transactionHash'
});

exports.Prisma.ETHEventSyncStatusScalarFieldEnum = makeEnum({
  id: 'id',
  eTHNetworkId: 'eTHNetworkId',
  syncTopHash: 'syncTopHash',
  eventType: 'eventType'
});

exports.Prisma.ETHNetworkScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  chainId: 'chainId',
  networkId: 'networkId'
});

exports.Prisma.ETHWithdrawEventScalarFieldEnum = makeEnum({
  eTHEventId: 'eTHEventId',
  userAddress: 'userAddress',
  amount: 'amount'
});

exports.Prisma.Erc20AssetScalarFieldEnum = makeEnum({
  id: 'id',
  address: 'address',
  ethNetworkId: 'ethNetworkId'
});

exports.Prisma.ExampleScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.JsonNullValueFilter = makeEnum({
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
});

exports.Prisma.JsonNullValueInput = makeEnum({
  JsonNull: Prisma.JsonNull
});

exports.Prisma.LedgerScalarFieldEnum = makeEnum({
  id: 'id',
  assetId: 'assetId',
  accountId: 'accountId'
});

exports.Prisma.MarketMakerScalarFieldEnum = makeEnum({
  id: 'id',
  lastDailySpendingReset: 'lastDailySpendingReset'
});

exports.Prisma.MarketMakerSpendingScalarFieldEnum = makeEnum({
  makerId: 'makerId',
  betConfigId: 'betConfigId',
  spending: 'spending',
  periodHours: 'periodHours'
});

exports.Prisma.MoneyDumpScalarFieldEnum = makeEnum({
  id: 'id',
  description: 'description'
});

exports.Prisma.MoneySourceScalarFieldEnum = makeEnum({
  id: 'id',
  description: 'description'
});

exports.Prisma.OperationArbitraryScalarFieldEnum = makeEnum({
  id: 'id',
  description: 'description'
});

exports.Prisma.OperationBetCreationScalarFieldEnum = makeEnum({
  id: 'id',
  betId: 'betId',
  openPrice: 'openPrice',
  openPriceTimestampMs: 'openPriceTimestampMs',
  createdAt: 'createdAt'
});

exports.Prisma.OperationBetResolutionScalarFieldEnum = makeEnum({
  id: 'id',
  betId: 'betId',
  createdAt: 'createdAt',
  closePrice: 'closePrice',
  takerWon: 'takerWon'
});

exports.Prisma.OperationDepositScalarFieldEnum = makeEnum({
  id: 'id',
  eTHEventId: 'eTHEventId'
});

exports.Prisma.OperationScalarFieldEnum = makeEnum({
  id: 'id',
  type: 'type'
});

exports.Prisma.OperationWithdrawalScalarFieldEnum = makeEnum({
  id: 'id',
  requestExpiry: 'requestExpiry'
});

exports.Prisma.QueryMode = makeEnum({
  default: 'default',
  insensitive: 'insensitive'
});

exports.Prisma.ReadablePairScalarFieldEnum = makeEnum({
  pair: 'pair',
  readableName: 'readableName'
});

exports.Prisma.SortOrder = makeEnum({
  asc: 'asc',
  desc: 'desc'
});

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.TransferScalarFieldEnum = makeEnum({
  id: 'id',
  offset: 'offset',
  stamp: 'stamp',
  amount: 'amount',
  assetId: 'assetId',
  fromLedgerId: 'fromLedgerId',
  toLedgerId: 'toLedgerId',
  operationId: 'operationId'
});

exports.Prisma.UTMScalarFieldEnum = makeEnum({
  sessionId: 'sessionId',
  utmId: 'utmId',
  source: 'source',
  medium: 'medium',
  campaign: 'campaign',
  term: 'term',
  content: 'content'
});

exports.Prisma.UserScalarFieldEnum = makeEnum({
  id: 'id',
  ethAddress: 'ethAddress',
  email: 'email'
});

exports.Prisma.WithdrawalSignatureScalarFieldEnum = makeEnum({
  id: 'id',
  assetId: 'assetId',
  userId: 'userId',
  expirySec: 'expirySec',
  totalWithdrawal: 'totalWithdrawal'
});
exports.AccountType = makeEnum({
  STANDARD_USER: 'STANDARD_USER',
  BET: 'BET',
  MONEY_SOURCE: 'MONEY_SOURCE',
  MONEY_DUMP: 'MONEY_DUMP',
  MARKET_MAKER: 'MARKET_MAKER'
});

exports.AssetType = makeEnum({
  ETH: 'ETH',
  ERC_20: 'ERC_20',
  FIAT: 'FIAT'
});

exports.ETHEventType = makeEnum({
  DEPOSIT: 'DEPOSIT',
  WITHDRAWAL: 'WITHDRAWAL'
});

exports.OperationType = makeEnum({
  DEPOSIT: 'DEPOSIT',
  WITHDRAWAL: 'WITHDRAWAL',
  BET_CREATION: 'BET_CREATION',
  BET_RESOLUTION: 'BET_RESOLUTION',
  ARBITRARY: 'ARBITRARY'
});

exports.PriceSource = makeEnum({
  BINANCE: 'BINANCE'
});

exports.Prisma.ModelName = makeEnum({
  Example: 'Example',
  Asset: 'Asset',
  Erc20Asset: 'Erc20Asset',
  Ledger: 'Ledger',
  Account: 'Account',
  Bet: 'Bet',
  User: 'User',
  MarketMaker: 'MarketMaker',
  MarketMakerSpending: 'MarketMakerSpending',
  MoneySource: 'MoneySource',
  MoneyDump: 'MoneyDump',
  ETHAddress: 'ETHAddress',
  ETHNetwork: 'ETHNetwork',
  Transfer: 'Transfer',
  Operation: 'Operation',
  OperationDeposit: 'OperationDeposit',
  OperationWithdrawal: 'OperationWithdrawal',
  OperationBetCreation: 'OperationBetCreation',
  OperationBetResolution: 'OperationBetResolution',
  OperationArbitrary: 'OperationArbitrary',
  ReadablePair: 'ReadablePair',
  BetConfigurationHistory: 'BetConfigurationHistory',
  BetConfiguration: 'BetConfiguration',
  DataMigration: 'DataMigration',
  ETHBlock: 'ETHBlock',
  ETHEventSyncStatus: 'ETHEventSyncStatus',
  ETHEvent: 'ETHEvent',
  ETHDepositEvent: 'ETHDepositEvent',
  ETHWithdrawEvent: 'ETHWithdrawEvent',
  WithdrawalSignature: 'WithdrawalSignature',
  AnalyticsEvent: 'AnalyticsEvent',
  UTM: 'UTM'
});

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
